import { render } from "./FlyingBird.vue?vue&type=template&id=4734cb02&scoped=true"
import script from "./FlyingBird.vue?vue&type=script&lang=js"
export * from "./FlyingBird.vue?vue&type=script&lang=js"

import "./FlyingBird.vue?vue&type=style&index=0&id=4734cb02&scoped=true&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4734cb02"]])

export default __exports__